import { ConfigSystem } from './@types/ConfigSystemModel';

export const CONFIG_SYSTEM_STORAGE_KEY = 'tk_config_system';

export class ConfigSystemRepository {
    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getConfigSystem(): Promise<ConfigSystem[]> {
        try {
            const response = await this.httpService.get<TKResponse<ConfigSystem[]>>('/config_system');
            return response.data;
        } catch (error) {
            console.error('Error al obtener la configuración del sistema:', error);
            throw error;
        }
    }
}
